import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROUTES } from 'src/app/constants';
import { ResetPasswordComponent } from './reset-password.component';

const routes: Routes = [
	{ path: ROUTES.ROOT, component: ResetPasswordComponent }
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})

export class ResetPasswordRoutingModule { }
